import { render, staticRenderFns } from "./CmsTemplateSelect.vue?vue&type=template&id=f1bbf456&"
import script from "./CmsTemplateSelect.vue?vue&type=script&lang=ts&"
export * from "./CmsTemplateSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports